import register from '@kpsys/angularjs-register';
import testRoutes from './playground/test-page.routes';
import svelteModule from './svelte.module';


export default register('portaro.svelte-test-module', [svelteModule])
    .config(testRoutes)
    .name()